import { isArray, isNaN } from 'lodash';

const parseSearchQuery = (query) => {
  const parsedQuery = { ...query };
  Object.keys(parsedQuery).forEach((key) => {
    parsedQuery[key] = !isNaN(+parsedQuery[key]) ? +parsedQuery[key] : parsedQuery[key];
    parsedQuery[key] = parsedQuery[key] === 'true' ? true : parsedQuery[key];
    parsedQuery[key] = parsedQuery[key] === 'false' ? false : parsedQuery[key];
    parsedQuery[key] = isArray(parsedQuery[key])
      ? parsedQuery[key].map((value, i) => (!isNaN(+value) ? +value : parsedQuery[key][i]))
      : parsedQuery[key];
  });

  return parsedQuery;
};

export default parseSearchQuery;
